import { gql } from '@apollo/client';

export const FORCE_RUN_HISTORICAL_IMPORT = gql`
    mutation ForceRunHistoricalImport($id: ID!) {
        forceRunHistoricalImport(id: $id) {
            id
            status
            scheduledFor
            fileName
            createdAt
        }
    }
`;
